import { useEffect } from 'react';
import {
  HomeHeroAuthenticationStep,
  useHomeHeroAuthenticationStepActions,
} from '@/store/authentication/AuthenticationStore';
import StorageManager from '@/shared/storageManager';

/*
 This hook is responsible for setting the initial "HomeHeroAuthenticationStep" value
 */
const useInitialAuthFlow = () => {
  const { setHomeHeroAuthenticationStep, setLoginFlowVariant } =
    useHomeHeroAuthenticationStepActions();

  useEffect(() => {
    const returningUserLoginMethod = StorageManager.getIsReturningUser();
    if (returningUserLoginMethod) {
      setLoginFlowVariant(returningUserLoginMethod);
      setHomeHeroAuthenticationStep(HomeHeroAuthenticationStep.Login);
    }
  }, []);
};

export default useInitialAuthFlow;
